// extracted by mini-css-extract-plugin
export default {"dialogButtonContainer":"StudentView_dialogButtonContainer__ZRABz"};